import { Component, Input, Output, EventEmitter } from '@angular/core';

import { visualizacaoModoList, visualizacaoModoDashboard, isVisualizacaoModoDashboard, isVisualizacaoModoList, VisualizacaoModo } from '../../../common/visualizacao-modo';
import { TituloReceberVisualizacao } from './titulo-receber-visualizacao';
import { TituloReceberVisualizacaoStorageService } from './titulo-receber-visualizacao-storage.service';

@Component({
    selector: 'sgt-titulo-receber-visualizacao',
    templateUrl: './titulo-receber-visualizacao.component.html',
    styleUrls: ['./titulo-receber-visualizacao.component.less']
})
export class TituloReceberVisualizacaoComponent {
    visualizacaoModos = [visualizacaoModoList, visualizacaoModoDashboard];

    @Input() storageKey: string;
    @Input() visualizacao: TituloReceberVisualizacao;
    @Input() modoDefault: VisualizacaoModo = visualizacaoModoList;
    @Output() visualizacaoChange = new EventEmitter<TituloReceberVisualizacao>();
    @Output() changeModo = new EventEmitter<void>();

    constructor(private tituloReceberVisualizacaoStorageService: TituloReceberVisualizacaoStorageService) { }

    ngOnInit(): void {
        this.visualizacao = this.tituloReceberVisualizacaoStorageService.get(this.storageKey, this.modoDefault);
        this.visualizacaoChange.emit(this.visualizacao);
    }

    /** Ao alterar o modo de visualização */
    onChangeVisualizacaoModo(modo: number) {
        this.visualizacao.modo = modo;
        setTimeout(() => this.changeModo.emit(), 0);
    }

    /** Verifica se o modo de visualização selecionado é o modo Table */
    isModoTable(): boolean {
        return isVisualizacaoModoList(this.visualizacao?.modo);
    }

    /** Verifica se o modo de visualização selecionado é o modo Dashboard */
    isModoDashboard(): boolean {
        return isVisualizacaoModoDashboard(this.visualizacao?.modo);
    }

    setStorage() {
        // Visualização
        this.tituloReceberVisualizacaoStorageService.set(this.storageKey, this.visualizacao);
    }
}
